module.exports = __webpack_public_path__ + "img/staff-photo-2.1dc212b.webp";